<template>
  <div
    :class="[
      'wrapper',
      { chart: isChart },
      { scoreless: metric.score === null },
    ]"
  >
    <div class="metric-item skeleton" v-if="!metric.category_id">
      <div class="icon highlight"></div>
      <div class="metric-info mt-2 mr-4 ml-4">
        <h4 class="highlight"></h4>
        <div class="bar highlight"></div>
      </div>
    </div>
    <div
      :title="metric.label"
      :class="['metric-item', 'ie-11-img', { 'no-border': metric.noBorder }]"
      v-metric-color
      :data-metric-value="normalizeScore"
      v-show="metric.category_id && !isChart"
      @click="$emit('showDetails')"
    >
      <div
        class="icon"
        v-metric-color
        :data-metric-value="normalizeScore"
        :value="score"
        v-if="metric.image"
      >
        <div
          :style="{
            'background-image': `url(${getImageUrl(
              'culture',
              `${metric.image}.svg`
            )})`,
          }"
        ></div>
      </div>
      <div
        v-else
        class="icon"
        v-metric-color
        :data-metric-value="normalizeScore"
        :value="score"
      >
        <div
          :style="{
            'background-image': `url(${getImageUrl(
              'custom-surveys',
              'no-image.png'
            )})`,
          }"
        ></div>
      </div>
      <div class="metric-info">
        <h4>
          <div class="metric-title">{{ metric.label }}</div>
        </h4>
        <p class="mt-1" v-if="metric.text">{{ metric.text }}</p>
        <span class="show-details">
          {{ resources.component.metricItem.showDetails }}
        </span>
        <div class="bar" v-if="metric.score !== null">
          <b-progress :max="10" class="flex-100 ie-11-progress" show-progress>
            <b-progress-bar
              v-metric-color
              :data-metric-value="normalizeScore"
              :value="score"
              :label="' '"
            ></b-progress-bar>
          </b-progress>
          <span
            class="label"
            v-metric-color
            :data-metric-value="normalizeScore"
          >
            {{ metric.scoreLabel }}
          </span>
        </div>
      </div>
    </div>
    <div class="metric-item-chart" v-show="metric.category_id && isChart">
      <b-row class="m-0">
        <div
          class="icon mr-3"
          v-metric-color
          :data-metric-value="normalizeScore"
          v-if="metric.image"
        >
          <div
            :style="{
              'background-image': `url(${getImageUrl(
                'culture',
                `${metric.image}.svg`
              )})`,
            }"
          ></div>
        </div>
        <div
          v-else
          class="icon mr-3"
          v-metric-color
          :data-metric-value="normalizeScore"
        >
          <div
            :style="{
              'background-image': `url(${getImageUrl(
                'custom-surveys',
                'no-image.png'
              )})`,
            }"
          ></div>
        </div>

        <div class="metric-info">
          <div class="label">{{ metric.label }}</div>
          <span class="show-details clickable" @click="$emit('showDetails')">
            {{ resources.component.metricItem.showDetails }}
          </span>
        </div>
      </b-row>
      <HistoricChart
        v-if="metric.score !== null"
        :history="metric.history"
      ></HistoricChart>
      <div v-else class="history-wrapper">
        <div class="history-placeholder"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HistoricChart from '@/components/CustomSurveys/Reports/HistoricChart.vue'

const props = {
  metric: {
    default: function() {
      return { score: undefined }
    },
    require: true,
    type: Object,
  },
  metricType: {
    default: 'list',
    require: false,
    type: String,
  },
}

export default {
  components: {
    HistoricChart,
  },
  props: props,
  computed: {
    ...mapGetters({
      resources: 'resources',
    }),
    isChart: function() {
      return this.metricType === 'chart'
    },
    normalizeScore: function() {
      return this.metric.score
    },
  },
  methods: {
    metricLink: function() {
      if (this.metric.link) this.$router.push(this.metric.link)
    },
    getImageUrl(section, image) {
      return `https://static.teamculture.com.br/images/${section}/${image}`
    },
  },
  data: function() {
    return {
      score: undefined,
    }
  },
  created: function() {
    if (this.metric.score) {
      setInterval(() => (this.score = parseFloat(this.metric.score)))
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/styles/custom/colors';

_:-ms-fullscreen,
:root .ie-11-progress {
  background-color: green;
  max-width: 80%;
}

_:-ms-fullscreen,
:root .ie-11-img {
  height: 100px;
}

.wrapper {
  margin: 1%;
  min-width: 280px;
  width: 48%;

  @media (max-width: 700px) {
    width: 100%;
  }

  &.chart {
    width: 50%;
    margin: 0rem;

    @media (max-width: 700px) {
      width: 100%;
      border: 0px;
      &.wrapper:not(:nth-last-child(-n + 1)) {
        border-bottom: 0.5px solid map-get($theme-colors, 'gray07');
      }
    }

    @media (min-width: 768px) {
      &.wrapper:nth-of-type(odd) {
        border-right: 0.5px solid map-get($theme-colors, 'gray07');
      }

      &.wrapper:not(:nth-last-child(-n + 2)) {
        border-bottom: 0.5px solid map-get($theme-colors, 'gray07');
      }
    }

    &.scoreless {
      border: 0px !important;
    }
  }
}

.metric-item-chart {
  border: 0px;
  margin: 30px 0px 10px 20px;

  .metric-info {
    display: inline-flex;
    flex-direction: column;
    justify-content: center;

    .label {
      font-size: 20px;
      font-weight: 500;
      color: map-get($theme-colors, 'gray04');

      @media (max-width: 1350px) {
        font-size: 16px !important;
      }
    }

    .show-details {
      color: map-get($theme-colors, 'gray03');
      font-size: 12px;
      font-weight: 500;
      text-decoration: none;
      margin-top: 0px;

      @media (max-width: 1350px) {
        font-size: 10px !important;
      }
    }
  }

  .icon {
    border-radius: 50%;
    min-height: 50px;
    min-width: 50px;

    div {
      min-height: inherit;
      height: 100%;
      width: 100%;
      border-radius: 50%;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }

  .history {
    padding: 0px;
    margin-top: 20px;
  }
}

.metric-item {
  border: 1px solid rgba(83, 92, 145, 0.2);
  border-radius: 80px;
  color: map-get($theme-colors, 'light');
  display: flex;
  transition: all ease 0.3s;
  max-height: 100px;
  cursor: pointer;

  @media (max-width: 1350px) {
    max-height: 80px;
  }

  @media (max-width: 320px) {
    max-height: 80px;
  }

  .progress {
    background: white;
    border: 1px solid rgba(204, 204, 204, 0.5);
  }

  .icon {
    align-items: center;
    border-right: 1px solid rgba(83, 92, 145, 0.2);
    border-radius: inherit;
    color: white;
    display: flex;
    font-size: 4.2rem;
    justify-content: center;
    height: auto;
    min-height: 100px;
    min-width: 100px;
    max-width: 100px;
    overflow: hidden;

    @media (max-width: 1350px) {
      min-height: 80px;
      min-width: 80px;
      max-width: 80px;
    }

    @media (max-width: 320px) {
      min-height: 70px;
      min-width: 70px;
      max-width: 70px;
    }

    div {
      min-height: inherit;
      height: 100%;
      width: 100%;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
    }
  }

  &:hover {
    border: 1px solid
      lighten($color: map-get($theme-colors, 'purple01'), $amount: 40%);
    box-shadow: 0 3px 6px
      lighten($color: map-get($theme-colors, 'purple01'), $amount: 50%);
  }

  &.no-hover:hover {
    background: none;
    box-shadow: none;
    border: 0px;
    cursor: auto;
  }

  &.no-border {
    border: none;
  }

  .metric-info {
    border-radius: 0 8px 8px 0;
    display: inline-flex;
    flex-direction: column;
    justify-content: center;
    padding: 0.5rem 1.2rem 0.7rem 0.5rem;
    margin: 0.5rem 0.6rem 0rem 0.7rem;
    width: 100%;
    min-width: calc(100% - 100px);
    max-width: calc(100% - 100px);

    @media (max-width: 1350px) {
      min-width: calc(100% - 80px);
      max-width: calc(100% - 80px);
    }

    @media (max-width: 320px) {
      min-width: calc(100% - 70px);
      max-width: calc(100% - 70px);
    }

    @media (max-width: 1375px) {
      padding: 0.2rem 1rem 0.2rem 0rem;
    }

    h4 {
      border-radius: 30px;
      color: map-get($theme-colors, 'gray04');
      font-size: 20px;
      font-weight: 500;
      margin-bottom: 0px;

      .metric-title {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }

      @media (max-width: 1350px) {
        font-size: 13px;
      }

      @media (max-width: 320px) {
        font-size: 14px;
      }
    }

    span.show-details,
    a {
      color: map-get($theme-colors, 'gray03');
      font-size: 12px;
      text-decoration: none;

      @media (max-width: 1350px) {
        font-size: 10px !important;
      }

      @media (max-width: 320px) {
        font-size: 9px !important;
      }
    }

    p {
      color: map-get($theme-colors, 'gray02');
      font-size: 12px;
      text-decoration: none;
      margin: 0;
    }

    .show-details {
      margin-top: 4px;
      font-weight: 500;
      font-size: 12px;
    }

    .bar {
      display: flex;
      align-items: center;

      .label {
        font-weight: 500;
        font-size: 29px;
        line-height: normal;
        margin-bottom: 5px;
        margin-right: 1rem;
        width: 45px;
        text-align: center;

        @media (max-width: 1350px) {
          font-size: 20px !important;
          width: 35px;
        }
      }

      .progress {
        height: 10px;
        border-radius: 30px;
        flex-basis: 100%;
        margin-right: 1rem;

        @media (max-width: 1350px) {
          height: 8px;
        }

        .progress-bar {
          border-radius: 30px;
        }
      }
    }
  }

  &.skeleton {
    .highlight {
      background: linear-gradient(
        70deg,
        map-get($theme-colors, 'light'),
        map-get($theme-colors, 'light'),
        white,
        map-get($theme-colors, 'light')
      );
      background-size: 300% 300%;
      animation: lightAnimate 1s ease infinite;
    }

    .icon {
      border-right: none;
    }

    .metric-info {
      h4 {
        height: 20px;
        width: 50%;
      }

      .bar {
        border-radius: 30px;
        height: 28px;
        margin-right: 1rem;
        width: 90%;
      }
    }

    @keyframes lightAnimate {
      0% {
        background-position: 100% 0%;
      }
      100% {
        background-position: 0% 0%;
      }
    }
  }
}
</style>
